// <generated-client-wrappers:imports>
import type * as WrapperApi from '../generated/model/models';
import type * as WrapperHttp from '@angular/common/http';
import type * as WrapperRx from 'rxjs';
// </generated-client-wrappers:imports>
import { Injectable } from '@angular/core';
import { FeedbackOperationsService } from '../generated/api/feedbackOperations.service';

@Injectable({ providedIn: 'root' })
export class FeedbackOperationsClientService {
  constructor(private readonly client: FeedbackOperationsService) {}
  // <generated-client-wrappers:methods>
  addComment(
    id: string,
    request: WrapperApi.FeedbackCommentRequest,
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: '*/*';
      context?: WrapperHttp.HttpContext;
      transferCache?: boolean;
    },
  ): WrapperRx.Observable<Blob> {
    if (!this.client)
      throw new Error('FeedbackOperationsService is not available');
    return this.client.feedbackOperationsAddComment(
      id,
      request,
      'body',
      reportProgress,
      options,
    );
  }

  assign(
    id: string,
    request: WrapperApi.FeedbackAssignRequest,
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: '*/*';
      context?: WrapperHttp.HttpContext;
      transferCache?: boolean;
    },
  ): WrapperRx.Observable<Blob> {
    if (!this.client)
      throw new Error('FeedbackOperationsService is not available');
    return this.client.feedbackOperationsAssign(
      id,
      request,
      'body',
      reportProgress,
      options,
    );
  }

  get(
    id: string,
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: WrapperHttp.HttpContext;
      transferCache?: boolean;
    },
  ): WrapperRx.Observable<WrapperApi.FeedbackDetail> {
    if (!this.client)
      throw new Error('FeedbackOperationsService is not available');
    return this.client.feedbackOperationsGet(
      id,
      'body',
      reportProgress,
      options,
    );
  }

  publish(
    id: string,
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: '*/*';
      context?: WrapperHttp.HttpContext;
      transferCache?: boolean;
    },
  ): WrapperRx.Observable<Blob> {
    if (!this.client)
      throw new Error('FeedbackOperationsService is not available');
    return this.client.feedbackOperationsPublish(
      id,
      'body',
      reportProgress,
      options,
    );
  }

  query(
    request: WrapperApi.FeedbackQueryRequest,
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: WrapperHttp.HttpContext;
      transferCache?: boolean;
    },
  ): WrapperRx.Observable<WrapperApi.FeedbackPage> {
    if (!this.client)
      throw new Error('FeedbackOperationsService is not available');
    return this.client.feedbackOperationsQuery(
      request,
      'body',
      reportProgress,
      options,
    );
  }

  setStatus(
    id: string,
    request: WrapperApi.FeedbackStatusRequest,
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: '*/*';
      context?: WrapperHttp.HttpContext;
      transferCache?: boolean;
    },
  ): WrapperRx.Observable<Blob> {
    if (!this.client)
      throw new Error('FeedbackOperationsService is not available');
    return this.client.feedbackOperationsSetStatus(
      id,
      request,
      'body',
      reportProgress,
      options,
    );
  }

  unpublish(
    id: string,
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: '*/*';
      context?: WrapperHttp.HttpContext;
      transferCache?: boolean;
    },
  ): WrapperRx.Observable<Blob> {
    if (!this.client)
      throw new Error('FeedbackOperationsService is not available');
    return this.client.feedbackOperationsUnpublish(
      id,
      'body',
      reportProgress,
      options,
    );
  }

  update(
    id: string,
    request: WrapperApi.FeedbackUpdateRequest,
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: '*/*';
      context?: WrapperHttp.HttpContext;
      transferCache?: boolean;
    },
  ): WrapperRx.Observable<Blob> {
    if (!this.client)
      throw new Error('FeedbackOperationsService is not available');
    return this.client.feedbackOperationsUpdate(
      id,
      request,
      'body',
      reportProgress,
      options,
    );
  }
  // </generated-client-wrappers:methods>
}
